/**
 * Legal Footer Component — ADM Responsible Gambling
 * Rendered inline at the bottom of every page's scrollable content.
 * User scrolls down to see it (NOT sticky).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, COMPANY } from '../config';

const LegalFooter = ({ showLinks = true }) => (
  <div className="mt-8 pt-6 pb-32 border-t border-white/10 text-center space-y-3" data-testid="legal-footer">
    {/* +18 Banner — internal page (Gioco Responsabile) + clickable phone */}
    <div className="flex items-center justify-center gap-2 py-2 px-4 bg-[#1a472a]/30 border border-green-800/30 rounded-xl">
      <Link
        to="/gioco-responsabile"
        className="flex items-center gap-2 text-xs active:opacity-70"
        data-testid="responsible-gambling-banner"
      >
        <span className="text-green-500 font-bold">+18</span>
        <span className="text-gray-400">Gioca Responsabile</span>
      </Link>
      <span className="text-gray-500 text-[10px]">|</span>
      <a
        href="tel:800558822"
        className="text-gray-500 text-[10px] active:text-emerald-400"
        data-testid="responsible-gambling-phone"
      >
        Telefono Verde: 800 558 822
      </a>
    </div>

    {/* Bookmaker disclaimer */}
    <p className="text-xs text-gray-400 font-medium">
      ⚠️ {BRAND.name} non è un bookmaker e non accetta scommesse.
    </p>

    {/* ADM probabilità */}
    <p className="text-[10px] text-gray-500">
      Consulta le probabilità di vincita su{' '}
      <a href="https://www.adm.gov.it" target="_blank" rel="noopener noreferrer" className="text-[#F5A623] hover:underline">
        www.adm.gov.it
      </a>
    </p>

    {/* Legal links */}
    {showLinks && (
      <div className="flex justify-center gap-4 text-xs">
        <Link to="/terms" className="text-gray-400 hover:text-[#F5A623] transition-colors">Termini</Link>
        <Link to="/privacy-policy" className="text-gray-400 hover:text-[#F5A623] transition-colors">Privacy</Link>
        <Link to="/cookie-policy" className="text-gray-400 hover:text-[#F5A623] transition-colors">Cookie</Link>
      </div>
    )}

    {/* Copyright */}
    <div className="text-[10px] text-gray-600">
      <p>© {new Date().getFullYear()} {COMPANY.name} · P.IVA {COMPANY.piva}</p>
    </div>
  </div>
);

export default LegalFooter;
